import { useQuery } from '@apollo/client';
import basketApi from 'api/baskeApi';
import basketQuery from 'api/graphql/basket';
import { Cart } from 'gql/graphql';
import useIsServer from 'hooks/useIsServer';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setCartAction, setCartItemsFetchingAction, setCartTotalFetchingAction } from 'store/cart/slice';
import { BasketItemAttr } from './types';

const useBasketData = () => {
  const dispatch = useDispatch();
  const isServer = useIsServer();
  const customerId =
    !isServer && window && window.dataLayer && window.dataLayer[0] ? (window.dataLayer[0] as any).customerId : 7207009;

  const {
    data: basketQueryResult,
    loading: loadingBasketQuery,
    error: errorLoadingBasketQuery,
  } = useQuery(basketQuery, { notifyOnNetworkStatusChange: true });

  useEffect(() => {
    dispatch(setCartItemsFetchingAction(loadingBasketQuery));
    dispatch(setCartTotalFetchingAction(loadingBasketQuery));
    if (!loadingBasketQuery && basketQueryResult) {
      dispatch(setCartAction(basketQueryResult.cart_query as Cart));
    }
  }, [basketQueryResult, loadingBasketQuery]);

  const onEditItem = (orderItemId: number) => {
    // eslint-disable-next-line no-console
    console.log('edit item', orderItemId);
  };

  const onApplyVoucher = async (voucherCode: string) => {
    // setFetchingTotal(true);
    await basketApi.applyVoucherCode(voucherCode);
    // setFetchingTotal(false);
  };

  const onRemoveVoucher = async (voucherId: string) => {
    // setFetchingTotal(true);
    // await basketApi.removeVoucherCode(voucherId);
    // setFetchingTotal(false);
  };

  const onChangeSelector = async (orderItemId: number, attr: BasketItemAttr) => {
    // fetch options
  };

  const fetchBasketDelivery = async () => {
    // setFetchingDelivery(true);
    // const basketDelivery = (await basketApi.fetchBasketDelivery()) as BasketDelivery;
    // basketDelivery && setDelivery(basketDelivery);
    // setFetchingDelivery(false);
  };

  const fetchWholeBasket = async () => {
    // fetchAllBasketItems();
    // fetchBasketTotal();
    fetchBasketDelivery();
  };

  const onRemoveItem = async (orderItemId: number) => {
    // eslint-disable-next-line no-console
    console.log('remove item', orderItemId);
    // setFetchingOrderItemId(orderItemId);
    // await basketApi.removeBasketItem(orderItemId);
    // await basketApi.delay(1000);
    // setFetchingOrderItemId(0);
    // fetchWholeBasket();
  };

  return {
    onRemoveItem,
    onEditItem,
    onApplyVoucher,
    onRemoveVoucher,
    onChangeSelector,
  };
};

export default useBasketData;
